import React from "react";
import Routes from "./routes/index";
import "./styles/global";
import history from "./services/history";
import Cookies from './components/Cookies'
import { createMuiTheme, ThemeProvider } from "@material-ui/core";
import ModalEvent from './components/Admin/ModalEvent';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#1b1c1d',
      contrastText: '#fff'
    }
  },
  typography: {
    fontFamily: 'Montserrat'
  },
  overrides: {
    MuiTableCell: {
      sizeSmall: {
        height: '30px',
        padding: '0 24px 0 16px'
      }
    },
  }
})

const App = () => (
  <ThemeProvider theme={theme}>
    <div>
      <Cookies />
      <Routes history={history} />
      {/* <ModalEvent /> */}
    </div>
  </ThemeProvider>
);
export default App;
